import React from "react";
import FeedList from '../components/FeedList';
import {
  Box,
  Stack,
  Typography,
  Avatar,
  Skeleton
} from '@mui/material';
import { useParams, useOutletContext } from 'react-router-dom';
import { useApiManager } from "lib/ApiContext";

const CreatorPage = () => {
  const api = useApiManager();
  const { nickname } = useParams();
  const { openPublish, errorToShow } = useOutletContext() || {};

  const [CData, setCData] = React.useState(null);
  const [HeaderURL, setHeaderURL] = React.useState(null);
  const [LogoURL, setLogoURL] = React.useState(null);

  const fetchData = async () => {
    if (nickname && api) {
      const Data = await api.GetCreatorByNickname(nickname);
      setCData(Data);
      if (Data?.Header) {
        const ImageURLData = await api.GetImageURL(Data.Header);
        setHeaderURL(ImageURLData?.url);
      }
      if (Data?.Logo) {
        const LogoURLData = await api.GetImageURL(Data.Logo);
        setLogoURL(LogoURLData?.url);
      }
    }
  };

  React.useEffect(() => {
    fetchData();
  }, [nickname, api]);

  return (
    <>
      {CData ? (
        <Box sx={{ width: "100%", maxWidth: "100vw", overflow: "hidden" }}>
          {/* Banner superior */}
          <Box
            sx={{
              height: { xs: 140, sm: 180, md: 260 },
              width: "100%",
              borderRadius: 2,
              backgroundImage: HeaderURL ? `url(${HeaderURL})` : "none",
              backgroundSize: "cover",
              backgroundPosition: "center",
              position: "relative",
              overflow: "hidden",
              boxSizing: "border-box",
               mt: { xs: "15px", sm: "72px", md: "0px" },
            }}
          />

          {/* Avatar + texto alineados a la izquierda */}
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            sx={{
              mt: { xs: -5, sm: -6, md: -7 }, // si quieres que solape un poco el banner
              ml: { xs: 2, sm: 4, md: 8 },
              position: "relative",
              zIndex: 10,
            }}
          >
            <Avatar
              src={LogoURL}
              alt={CData?.Name}
              sx={{
                width: { xs: 70, sm: 80, md: 88 },
                height: { xs: 70, sm: 80, md: 88 },
                border: "4px solid #0A0A12",
                boxShadow: 3,
              }}
            />
            <Typography
              sx={{
                fontSize: { xs: 18, sm: 28, md: 40 },
                fontWeight: 700,
                color: "#EDE9F7",
                textShadow: `
                  -1px -1px 0 #0A0A12,
                   1px -1px 0 #0A0A12,
                  -1px  1px 0 #0A0A12,
                   1px  1px 0 #0A0A12
                `,
                lineHeight: 1.2,
                wordBreak: "break-word",
                overflowWrap: "break-word",
                maxWidth: "calc(100% - 120px)",
              }}
            >
              {CData?.Name}
            </Typography>
          </Stack>

          {/* Contenido inferior */}
          <Box
            sx={{
              mt: { xs: 3, sm: 4, md: 5 },
              px: { xs: 1, sm: 2, md: 0 },
              width: "100%",
              maxWidth: "100%",
              boxSizing: "border-box",
            }}
          >
            <FeedList
              creator={CData.IDCreator}
              isDirty={openPublish}
              setErrorToShow={errorToShow}
            />
          </Box>
        </Box>
      ) : (
        <Box sx={{ p: { xs: 2, sm: 3 } }}>
          <Skeleton variant="rectangular" width="100%" height={80} sx={{ mb: 2, maxWidth: 300 }} />
          <Skeleton variant="rectangular" width="100%" height={730} sx={{ maxWidth: 630 }} />
        </Box>
      )}
    </>
  );
};

export default CreatorPage;
